
import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { SchedulerBaseService } from "./scheduler.base.service";
import { LollyBaseService } from "./lolly-base-services/lolly-base.service";
import { conflictPayload } from "app/models/bookings.model";
@Injectable({
  providedIn: "root",
})
export class LollySchedulerService extends LollyBaseService {

  constructor(public provider: ServiceProvider) {
    super("api/account/scheduler", provider);
    
  }

  public approveOrCancelAppointment(data = {}, appointmentId:string,approve :boolean ){
    const action = approve ? 'confirm' : 'cancel'
		return this.save(data,`/session/${appointmentId}/${action}`)
	}

  public cancelBooking(data = {}, appointmentId:string){
		return this.save(data,`/session/${appointmentId}/cancel`)
	}

  public confirmBooking(data = {}, appointmentId:string){
		return this.save(data,`/session/${appointmentId}/confirm`)
	}

  public getBookingData(id:string ){
   
		return this.getRecord(`/session/${id}/load`)
	}

  public getConflictSlots(payload:conflictPayload ){
   
		return this.getRecord(`/user/${payload.userId}/slots?date=${payload.date}`)
	}
}